import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUIIcon from '@mui/icons-material';

const Theme = Common.Theme;

export const ArrowDownIcon = styled(MUIIcon.KeyboardArrowDown)`
	margin-top: -0.1rem;
	margin-left: auto;
	color: ${Theme.green};
`;

export const DSOIcon = styled(MUIIcon.Business)`
	font-size: 16px !important;
`;

export const CalendarIcon = styled(MUIIcon.DateRange)`
	font-size: 16px !important;
`;

export const StatusIcon = styled(MUIIcon.Beenhere)`
	font-size: 16px !important;
`;

export const ProcessingIcon = styled(MUIIcon.Sync)`
	font-size: 16px !important;
	padding: 5px;
`;

export const AddIcon = styled(MUIIcon.PlaylistAddOutlined)`
	font-size: 16px !important;
	padding: 5px;
`;

export const DownloadIcon = styled(MUIIcon.SystemUpdateAlt)`
	font-size: 16px !important;
	padding: 5px;
`;

export const CloseIcon = styled(MUIIcon.Close)`
	font-size: 16px !important;
`;

export const ArrowBackIcon = styled(MUIIcon.ArrowBack)`
	font-size: 16px !important;
`;

export const LinkIcon = styled(MUIIcon.Link)`
	font-size: 16px !important;
`;

export const CartIcon = styled(MUIIcon.ShoppingCart)`
	font-size: 24px !important;
`;

export const ProfileIcon = styled(MUIIcon.PersonOutline)`
	font-size: 24px !important;
`;

export const RefreshInventoryIcon = styled(MUIIcon.Sync)`
	font-size: 16px !important;
	color: ${Theme.white} !important;
`;